<h3 style="width: 100%; text-align: center; margin-bottom: 35px">
  {{ reportDetails == undefined ? "" : reportDetails.Description }}
</h3>
<nz-skeleton [hidden]="!loading"> </nz-skeleton>
<nz-collapse [hidden]="loading">
  <nz-collapse-panel
    #parametersPanel
    [nzHeader]="'Parameters' | locale"
    [(nzActive)]="parametersPanelActive"
    [hidden]="!thereAreParameters"
  >
    <nz-space nzDirection="vertical" style="width: 100%">
      <nz-space-item>
        <app-parameters
          #reportParameters
          [reportId]="reportId"
          (loadingParametersCompleted)="loadingParametersCompleted($event)"
        >
        </app-parameters>
      </nz-space-item>
      <nz-space-item>
        <nz-row>
          <nz-col nz-col [nzPush]="8" [nzSpan]="16">
            <nz-space>
              <nz-space-item>
                <button nz-button (click)="loadTheReport()" nzType="primary">
                  {{ "Get Report" | locale }}
                </button>
              </nz-space-item>
              <nz-space-item>
                <button nz-button (click)="reset()">
                  {{ "Reset" | locale }}
                </button>
              </nz-space-item>
            </nz-space>
          </nz-col>
        </nz-row>
      </nz-space-item>
    </nz-space>
  </nz-collapse-panel>
  <nz-collapse-panel
    #resultPanel
    [nzHeader]="'Result' | locale"
    [(nzActive)]="resultPanelActive"
  >
    <nz-result
      *ngIf="!reportLoaded"
      nzStatus="info"
      [nzTitle]="'Fill the parameters and click on submit.'"
    >
    </nz-result>
    <app-viewer
      *ngIf="
        reportLoaded &&
        reportDetails != null &&
        reportDetails.Type !== layoutDefinitionType.CrystalReport
      "
      #reportViewer
      [reportParameters]="reportParameters"
      [reportId]="reportId"
    >
    </app-viewer>
    <nz-space
      nzDirection="vertical"
      style="width: 100%"
      *ngIf="
        reportLoaded &&
        reportDetails != null &&
        reportDetails.Type === layoutDefinitionType.CrystalReport
      "
    >
      <nz-space-item style="text-align: right">
        <a
          nz-button
          nzType="primary"
          [href]="reportSrc | safeHtml : 'resourceUrl'"
          target="_blank"
        >
          <i class="fal fa-arrow-up-right-from-square"></i>
          {{ "Open in new window" | locale }}
        </a>
      </nz-space-item>
      <nz-space-item>
        <iframe
          #reportViewer
          [src]="reportSrc | safeHtml : 'resourceUrl'"
          style="border: none; width: 100%; min-height: 600px"
        >
        </iframe>
      </nz-space-item>
    </nz-space>
  </nz-collapse-panel>
</nz-collapse>
